// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1aIZE","colMaxWidth":"Table_colMaxWidth__2bfkB"};